import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { DOCUMENT_TITLE_SUFFIX, SITE_DEFAULT_TITLE } from '../constants/documentTitle';

/**
 * Titles the document after a listing once its name is known. It re-applies on
 * pathname change so a redirect to the canonical URL, which also triggers the
 * site-wide reset in the same commit, still ends on the listing title.
 */
export function useDocumentTitle(name: string | null | undefined): void {
  const { pathname } = useLocation();

  useEffect(() => {
    if (name) {
      document.title = `${name}${DOCUMENT_TITLE_SUFFIX}`;
    }
  }, [name, pathname]);

  useEffect(
    () => () => {
      document.title = SITE_DEFAULT_TITLE;
    },
    [],
  );
}

/**
 * Restores the site default title on in-app navigation. The first render is
 * skipped so the title the server rendered survives.
 */
export function useDocumentTitleReset(): void {
  const { pathname } = useLocation();
  const previousPathname = useRef(pathname);

  useEffect(() => {
    if (previousPathname.current !== pathname) {
      previousPathname.current = pathname;
      document.title = SITE_DEFAULT_TITLE;
    }
  }, [pathname]);
}
